import { useBackendData } from 'services/useBackendData';

import { itemService } from './itemService';
import { withAuctionsForBulkItems } from './withAuctionsData';

const dataProvider = (itemId: number) => withAuctionsForBulkItems(() => itemService.fetchSimilarItems(itemId));

export const useSimilarItems = (itemId: number) => useBackendData(dataProvider, itemId);
